import Credits, { type CreditsProps } from "./Credits";
export { Credits as default, Credits, CreditsProps };